import type { FaireProductEntity } from "../../entity_types/product";

export const p_dkqzuzwymp: FaireProductEntity = {
  token: "p_dkqzuzwymp",
  type: "product",
  name: "Palo Santo Matchsticks",
  brandToken: "b_we9tdmh5ka",
  brandName: "The Sacred Wild Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/687bf44f6811a7e0cff0c93bbe3d6157af0ae7cfeff3418d576a4860e2e53544.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c45bef2ed17ac5f6d2d75048a4f19bae23fee895083ca64ffeea60455207e9ac.jpeg",
    "https://cdn.faire.com/fastly/95bc26adab679b60b30b53571d8233b13a4ffa2399857f43766ef9f1bd5aeb38.jpeg",
    "https://cdn.faire.com/fastly/93b779f5fb1437783029b18e5c4f53960bd1f5861d2e158302b99054a5947084.jpeg",
    "https://cdn.faire.com/fastly/db6bbfc5d5b3316d9aade28cc9a5aa50b0943a5fd5ac02c5c389cd27bd5cc007.jpeg",
    "https://cdn.faire.com/fastly/bb681c8df4f3ce03521a18db5942ea76be8290d6a2a444a1313c6c1309d1dbd5.jpeg",
  ],
  priceDollars: 9.7,
  description:
    "Our Palo Santo matchsticks are ethically sourced making them a sustainable solution to the waste created in cutting the wood to create the larger or more uniform sized sticks.  A self-lighting tip makes it easy to quickly smudge your home, office, or even your car.  *See below for order maximum info (2 per order max!) \n\nLike Sage, Sweetgrass, or Cedar, Palo Santo is most widely used for spiritual purification and energy (house) cleansing. \n\nOur Palo Santo matchsticks arrive in beautiful packaging and make a great gift for energy cleansing.\n\nWhy smudge your sacred space with Palo Santo?  \n\nPalo Santo means \"Holy Wood\" in Spanish and true to its name, this sacred tree from South America is often used in religious and healing ceremonies.\n\nSold in boxes of 20.   \n**At the moment we are able to lift our request of 2 boxes per customer...thanks all, for loving on these! **\n\n(standard: These are hard to keep in stock, and for our smaller/long-time customers, we'd appreciate a MAXIMUM order of 40, thank you. (LIMIT OF 2 CASES, of 20 each PER ORDER). thank you!) \n-----*Also, we can't ship this product internationally because of customs/import regulations, sorry!",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:51.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
